import React from 'react';

const LoadMoreButton = ({ setOffset, loading, offset, limit }) => {

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '24px',
  };

  const buttonStyle = {
    padding: '12px 24px',
    backgroundColor: loading ? '#cccccc' : '#f2ce1b',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    cursor: loading ? 'not-allowed' : 'pointer',
    fontSize: '16px',
    transition: 'background-color 0.3s ease',
  };

  const hoverStyle = !loading
    ? {
        backgroundColor: '#cfb019',
      }
    : {};

  const handleClick = () => {
    if (!loading) {
      setOffset(offset + limit);
    }
  };

  return (
    <div style={containerStyle}>
      <button
        onClick={handleClick}
        disabled={loading}
        style={{ ...buttonStyle, ...(hoverStyle) }}
      >
        {loading ? 'Loading...' : 'Load More'}
      </button>
    </div>
  );
};

export default LoadMoreButton;
